export enum IndeedCampaignObjectiveType {
    MAXIMUM = 1,
    BALANCE = 2,
    TARGET_APPLICATIONS = 3,
    TARGET_COST_PER_APPLICATION = 4,
}
